import React from "react";
import IranFlag from "../assets/images/iran-Flag-icon.png";
const PlateNumberComponent = (props) => {
  const { data } = props;
  if (!data) {
    return null;
  }

  const handleShowPlateNumber = () => {
    if (typeof data === "string") {
      const new_data = data.replace(/-/g, "");

      if (new_data.includes("الف")) {
        return (
          <>
            <div className="border-radius-main p-1 m-2">{new_data[0]}{new_data[1]}</div>
            <div className="border-radius-main p-1 m-2">{`${new_data[2]}${new_data[3]}${new_data[4]}`}</div>
            <div className="border-radius-main p-1 m-2">{new_data[5]}{new_data[6]}{new_data[7]}</div>
            <div
              className="border-radius-main p-1 m-2 ml-20"
              style={{ position: "relative" }}
            >
              {new_data[8]}{new_data[9]}
              <hr />
            </div>
          </>
        )
      }
      return (
        <>
          <div className="border-radius-main p-1 m-2">{new_data[0]}{new_data[1]}</div>
          <div className="border-radius-main p-1 m-2">{`${new_data[2]}`}</div>
          <div className="border-radius-main p-1 m-2">{new_data[3]}{new_data[4]}{new_data[5]}</div>
          <div
            className="border-radius-main p-1 m-2 ml-20"
            style={{ position: "relative" }}
          >
            {new_data[6]}{new_data[7]}
            <hr />
          </div>
        </>
      )
    }
    return (
      <>
        <div className="border-radius-main p-1 m-2">{data.number_plate_part_1}</div>
        <div className="border-radius-main p-1 m-2">{`${data.number_plate_alphabet}`}</div>
        <div className="border-radius-main p-1 m-2">{data.number_plate_part_2}</div>
        <div
          className="border-radius-main p-1 m-2 ml-20"
          style={{ position: "relative" }}
        >
          {data.plate_number_city_code || data.number_plate_city_code || ""}
          <hr />
        </div>
      </>
    )
  }

  return (
    <div className="plate-number-component">
      <div className="flex-row-reverse w-100 flex-content-center flex-items-center ">
        <div className="h-100 flex pb-3">
          <img src={IranFlag} alt="" width="15px" />
        </div>
        {handleShowPlateNumber()}
        <span>ایران</span>
      </div>
    </div>
  );
};

export default PlateNumberComponent;
